/**
 *
 * @fileoverview AppRoutingModule
 *
 * @version 1.0
 *
 * @author Milan Gotera <milangotera@gmail.com>
 *
 */

import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { GuardService } from './core/guards/guard.service';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'welcome',
    pathMatch: 'full',
  },
  {
    path: 'welcome',
    loadChildren: () => import('./modules/welcome/welcome.module').then((m) => m.WelcomePageModule),
  },
  {
    path: 'auth/login',
    loadChildren: () => import('./modules/auth/login/login.module').then((m) => m.LoginPageModule),
  },
  {
    path: 'auth/register',
    loadChildren: () => import('./modules/auth/register/register.module').then((m) => m.RegisterPageModule),
  },
  {
    path: 'auth/success',
    loadChildren: () => import('./modules/auth/success/success.module').then((m) => m.SuccessPageModule),
  },
  {
    path: 'auth/recover',
    loadChildren: () => import('./modules/auth/recover/recover.module').then((m) => m.RecoverPageModule),
  },
  {
    path: 'home',
    loadChildren: () => import('./modules/home/home.module').then((m) => m.HomePageModule),
    canActivate: [GuardService],
  },
  {
    path: 'ticket',
    loadChildren: () => import('./modules/ticket/ticket.module').then((m) => m.TicketPageModule),
    canActivate: [GuardService],
  },
  {
    path: 'profile',
    loadChildren: () => import('./modules/profile/profile/profile.module').then((m) => m.ProfilePageModule),
    canActivate: [GuardService],
  },
  {
    path: 'profile/about',
    loadChildren: () => import('./modules/profile/about/about.module').then((m) => m.AboutPageModule),
    canActivate: [GuardService],
  },
  {
    path: 'profile/account',
    loadChildren: () => import('./modules/profile/account/account.module').then((m) => m.AccountPageModule),
    canActivate: [GuardService],
  },
  {
    path: 'profile/session',
    loadChildren: () => import('./modules/profile/session/session.module').then((m) => m.SessionPageModule),
    canActivate: [GuardService],
  },
  {
    path: 'profile/password',
    loadChildren: () => import('./modules/profile/password/password.module').then((m) => m.PasswordPageModule),
    canActivate: [GuardService],
  },
  {
    path: 'profile/security',
    loadChildren: () => import('./modules/profile/security/security.module').then((m) => m.SecurityPageModule),
    canActivate: [GuardService],
  },
  {
    path: 'profile/emergency',
    loadChildren: () => import('./modules/profile/emergency/emergency.module').then((m) => m.EmergencyPageModule),
    canActivate: [GuardService],
  },
  {
    path: 'profile/contact',
    loadChildren: () => import('./modules/profile/contact/contact.module').then((m) => m.ContactPageModule),
    canActivate: [GuardService],
  },
  {
    path: 'profile/contact-add',
    loadChildren: () => import('./modules/profile/contact-add/contact-add.module').then((m) => m.ContactAddPageModule),
    canActivate: [GuardService],
  },
  {
    path: 'profile/contact-show',
    loadChildren: () =>
      import('./modules/profile/contact-show/contact-show.module').then((m) => m.ContactShowPageModule),
    canActivate: [GuardService],
  },
  {
    path: 'profile/data',
    loadChildren: () => import('./modules/profile/data/data.module').then((m) => m.DataPageModule),
    canActivate: [GuardService],
  },
  {
    path: 'profile/termins',
    loadChildren: () => import('./modules/profile/termins/termins.module').then((m) => m.TerminsPageModule),
    canActivate: [GuardService],
  },
  {
    path: 'profile/politics',
    loadChildren: () => import('./modules/profile/politics/politics.module').then((m) => m.PoliticsPageModule),
    canActivate: [GuardService],
  },
  {
    path: 'profile/help',
    loadChildren: () => import('./modules/profile/help/help.module').then((m) => m.HelpPageModule),
    canActivate: [GuardService],
  },
  {
    path: 'profile/help-detail',
    loadChildren: () => import('./modules/profile/help-detail/help-detail.module').then((m) => m.HelpDetailPageModule),
  },
  {
    path: 'profile/help-category',
    loadChildren: () =>
      import('./modules/profile/help-category/help-category.module').then((m) => m.HelpCategoryPageModule),
    canActivate: [GuardService],
  },
  {
    path: 'profile/suggest',
    loadChildren: () => import('./modules/profile/suggest/suggest.module').then((m) => m.SuggestPageModule),
    canActivate: [GuardService],
  },
  {
    path: 'profile/face-id',
    loadChildren: () => import('./modules/profile/face-id/face-id.module').then((m) => m.FaceIdPageModule),
  },
  {
    path: 'profile/wallet',
    loadChildren: () =>
      import('./modules/profile/profile-wallet/profile-wallet.module').then((m) => m.ProfileWalletPageModule),
    canActivate: [GuardService],
  },
  {
    path: 'profile/wallet/list',
    loadChildren: () =>
      import('./modules/profile/profile-wallet-list/profile-wallet-list.module').then(
        (m) => m.ProfileWalletListPageModule
      ),
    canActivate: [GuardService],
  },
  {
    path: 'profile/wallet/new',
    loadChildren: () =>
      import('./modules/profile/profile-wallet-new/profile-wallet-new.module').then(
        (m) => m.ProfileWalletNewPageModule
      ),
    canActivate: [GuardService],
  },
  {
    path: 'profile/wallet/amount',
    loadChildren: () =>
      import('./modules/profile/profile-wallet-amount/profile-wallet-amount.module').then(
        (m) => m.ProfileWalletAmountPageModule
      ),
    canActivate: [GuardService],
  },
  {
    path: 'notification',
    loadChildren: () => import('./modules/notification/notification.module').then((m) => m.NotificationPageModule),
    canActivate: [GuardService],
  },
  /* RESERVE */
  {
    path: 'reserve',
    loadChildren: () => import('./modules/reserve/reserve/reserve.module').then((m) => m.ReservePageModule),
    canActivate: [GuardService],
  },
  {
    path: 'reserve/summary',
    loadChildren: () => import('./modules/reserve/summary/summary.module').then((m) => m.SummaryPageModule),
    canActivate: [GuardService],
  },
  {
    path: 'reserve/confirm',
    loadChildren: () => import('./modules/reserve/confirm/confirm.module').then((m) => m.ConfirmPageModule),
    canActivate: [GuardService],
  },
  {
    path: 'reserve/response',
    loadChildren: () => import('./modules/reserve/response/response.module').then((m) => m.ResponsePageModule),
    canActivate: [GuardService],
  },
  {
    path: 'reserve/ticket',
    loadChildren: () => import('./modules/reserve/ticket/ticket.module').then((m) => m.TicketPageModule),
    canActivate: [GuardService],
  },
  {
    path: 'reserve/scan',
    loadChildren: () => import('./modules/reserve/scan/scan.module').then((m) => m.ScanPageModule),
    canActivate: [GuardService],
  },
  {
    path: 'reserve/scan-sumary',
    loadChildren: () => import('./modules/reserve/scan-sumary/scan-sumary.module').then((m) => m.ScanSumaryPageModule),
    canActivate: [GuardService],
  },
  {
    path: 'reserve/scan-confirm',
    loadChildren: () =>
      import('./modules/reserve/scan-confirm/scan-confirm.module').then((m) => m.ScanConfirmPageModule),
    canActivate: [GuardService],
  },
  /* MEMBERSHIPS */
  {
    path: 'memberships/home',
    loadChildren: () => import('./modules/memberships/home/home.module').then((m) => m.HomePageModule),
    canActivate: [GuardService],
  },
  {
    path: 'memberships/type',
    loadChildren: () => import('./modules/memberships/type/type.module').then((m) => m.TypePageModule),
    canActivate: [GuardService],
  },
  {
    path: 'memberships/select',
    loadChildren: () => import('./modules/memberships/select/select.module').then((m) => m.SelectPageModule),
    canActivate: [GuardService],
  },
  {
    path: 'memberships/filter',
    loadChildren: () => import('./modules/memberships/filter/filter.module').then((m) => m.FilterPageModule),
    canActivate: [GuardService],
  },
  {
    path: 'memberships/result',
    loadChildren: () => import('./modules/memberships/result/result.module').then((m) => m.ResultPageModule),
    canActivate: [GuardService],
  },
  {
    path: 'memberships/method',
    loadChildren: () => import('./modules/memberships/method/method.module').then((m) => m.MethodPageModule),
    canActivate: [GuardService],
  },
  {
    path: 'memberships/ticket',
    loadChildren: () => import('./modules/memberships/ticket/ticket.module').then((m) => m.TicketPageModule),
    canActivate: [GuardService],
  },
  /* ROUTES */
  {
    path: 'zones',
    loadChildren: () => import('./modules/routes/zones/zones.module').then((m) => m.ZonesPageModule),
    canActivate: [GuardService],
  },
  {
    path: 'location',
    loadChildren: () => import('./modules/routes/location/location.module').then((m) => m.LocationPageModule),
    canActivate: [GuardService],
  },
  {
    path: 'location/stop',
    loadChildren: () =>
      import('./modules/routes/location-stop/location-stop.module').then((m) => m.LocationStopPageModule),
    canActivate: [GuardService],
  },
  {
    path: 'location/search',
    loadChildren: () =>
      import('./modules/routes/location-search/location-search.module').then((m) => m.LocationSearchPageModule),
    canActivate: [GuardService],
  },
  {
    path: 'routes',
    loadChildren: () => import('./modules/routes/routes/routes.module').then((m) => m.RoutesPageModule),
    canActivate: [GuardService],
  },
  {
    path: 'routes/stops',
    loadChildren: () => import('./modules/routes/stops/stops.module').then((m) => m.StopsPageModule),
    canActivate: [GuardService],
  },
  {
    path: 'routes/map',
    loadChildren: () => import('./modules/routes/map/map.module').then((m) => m.MapPageModule),
    canActivate: [GuardService],
  },
  {
    path: 'routes/reserve',
    loadChildren: () => import('./modules/routes/reserve/reserve.module').then((m) => m.ReservePageModule),
    canActivate: [GuardService],
  },
  {
    path: 'routes/trips',
    loadChildren: () => import('./modules/routes/trips/trips.module').then((m) => m.TripsPageModule),
    canActivate: [GuardService],
  },
  {
    path: 'support',
    loadChildren: () => import('./modules/support/tickets/tickets.module').then((m) => m.TicketsPageModule),
    canActivate: [GuardService],
  },
  {
    path: 'support/new',
    loadChildren: () => import('./modules/support/new/new.module').then((m) => m.NewPageModule),
    canActivate: [GuardService],
  },
  {
    path: 'support/show',
    loadChildren: () => import('./modules/support/show/show.module').then((m) => m.ShowPageModule),
    canActivate: [GuardService],
  },
  {
    path: 'modal-alert',
    loadChildren: () => import('./modules/modals/modal-alert/modal-alert.module').then((m) => m.ModalAlertPageModule),
  },
  {
    path: 'modal-calendar',
    loadChildren: () =>
      import('./modules/modals/modal-calendar/modal-calendar.module').then((m) => m.ModalCalendarPageModule),
  },
  {
    path: 'bustickets',
    loadChildren: () => import('./modules/bustickets/bustickets/bustickets.module').then((m) => m.BusticketsPageModule),
    canActivate: [GuardService],
  },
  {
    path: 'bustickets/rate',
    loadChildren: () => import('./modules/bustickets/rate/rate.module').then((m) => m.RatePageModule),
    canActivate: [GuardService],
  },
  {
    path: 'modal-timetable',
    loadChildren: () =>
      import('./modules/modals/modal-timetable/modal-timetable.module').then((m) => m.ModalTimetablePageModule),
  },
  {
    path: 'modal-notification',
    loadChildren: () =>
      import('./modules/modals/modal-notification/modal-notification.module').then(
        (m) => m.ModalNotificationPageModule,
      ),
  },
  {
    path: 'modal-zones',
    loadChildren: () => import('./modules/modals/modal-zones/modal-zones.module').then((m) => m.ModalZonesPageModule),
  },
  {
    path: 'modal-contact-add',
    loadChildren: () =>
      import('./modules/modals/modal-contact-add/modal-contact-add.module').then((m) => m.ModalContactAddPageModule),
  },
  {
    path: 'modal-help',
    loadChildren: () => import('./modules/modals/modal-help/modal-help.module').then((m) => m.ModalHelpPageModule),
  },
  {
    path: 'modal-trips',
    loadChildren: () => import('./modules/modals/modal-trips/modal-trips.module').then((m) => m.ModalTripsPageModule),
  },
  /* DRIVER */
  {
    path: 'driver/login',
    loadChildren: () => import('./modules/driver/login/login.module').then((m) => m.LoginPageModule),
  },
  {
    path: 'driver/home',
    loadChildren: () => import('./modules/driver/home/home.module').then((m) => m.HomePageModule),
    canActivate: [GuardService],
  },
  {
    path: 'driver/profile',
    loadChildren: () => import('./modules/driver/profile/profile.module').then((m) => m.ProfilePageModule),
    canActivate: [GuardService],
  },
  {
    path: 'driver/routes',
    loadChildren: () => import('./modules/driver/routes/routes.module').then((m) => m.RoutesPageModule),
    canActivate: [GuardService],
  },
  {
    path: 'driver/tickets',
    loadChildren: () => import('./modules/driver/tickets/tickets.module').then((m) => m.TicketsPageModule),
    canActivate: [GuardService],
  },
  {
    path: 'driver/availability',
    loadChildren: () =>
      import('./modules/driver/availability/availability.module').then((m) => m.AvailabilityPageModule),
    canActivate: [GuardService],
  },
  {
    path: 'driver/scan-register',
    loadChildren: () =>
      import('./modules/driver/scan-register/scan-register.module').then((m) => m.ScanRegisterPageModule),
  },
  {
    path: 'driver/scan-upload',
    loadChildren: () => import('./modules/driver/scan-upload/scan-upload.module').then((m) => m.ScanUploadPageModule),
    canActivate: [GuardService],
  },
  {
    path: 'driver/scan-download',
    loadChildren: () =>
      import('./modules/driver/scan-download/scan-download.module').then((m) => m.ScanDownloadPageModule),
    canActivate: [GuardService],
  },
  {
    path: 'driver/scan-card',
    loadChildren: () => import('./modules/driver/scan-card/scan-card.module').then((m) => m.ScanCardPageModule),
    canActivate: [GuardService],
  },
  {
    path: 'driver/notification',
    loadChildren: () =>
      import('./modules/driver/notification/notification.module').then((m) => m.NotificationPageModule),
    canActivate: [GuardService],
  },
  {
    path: 'modal-support',
    loadChildren: () =>
      import('./modules/modals/modal-support/modal-support.module').then((m) => m.ModalSupportPageModule),
  },
  {
    path: 'modal-map',
    loadChildren: () => import('./modules/modals/modal-map/modal-map.module').then((m) => m.ModalMapPageModule),
  },
  {
    path: 'modal-subscription',
    loadChildren: () =>
      import('./modules/modals/modal-subscription/modal-subscription.module').then(
        (m) => m.ModalSubscriptionPageModule,
      ),
  },
  {
    path: 'modal-zoom',
    loadChildren: () => import('./modules/modals/modal-zoom/modal-zoom.module').then((m) => m.ModalZoomPageModule),
  },
  {
    path: 'modal-profile',
    loadChildren: () =>
      import('./modules/modals/modal-profile/modal-profile.module').then((m) => m.ModalProfilePageModule),
  },
  {
    path: 'modal-help-detail',
    loadChildren: () =>
      import('./modules/modals/modal-help-detail/modal-help-detail.module').then((m) => m.ModalHelpDetailPageModule),
  },
  {
    path: 'modal-enrollment',
    loadChildren: () =>
      import('./modules/modals/modal-enrollment/modal-enrollment.module').then((m) => m.ModalEnrollmentPageModule),
  },
  {
    path: 'modal-term',
    loadChildren: () => import('./modules/modals/modal-term/modal-term.module').then((m) => m.ModalTermPageModule),
  },
  {
    path: 'modal-location',
    loadChildren: () =>
      import('./modules/modals/modal-location/modal-location.module').then((m) => m.ModalLocationPageModule),
  },
  {
    path: 'modal-track',
    loadChildren: () => import('./modules/modals/modal-track/modal-track.module').then((m) => m.ModalTrackPageModule),
  },
  {
    path: 'modal-realtrips',
    loadChildren: () =>
      import('./modules/modals/modal-realtrips/modal-realtrips.module').then((m) => m.ModalRealtripsPageModule),
  },
  {
    path: 'modal-password',
    loadChildren: () =>
      import('./modules/modals/modal-password/modal-password.module').then((m) => m.ModalPasswordPageModule),
  },
  {
    path: 'modal-track',
    loadChildren: () => import('./modules/driver/modal-track/modal-track.module').then((m) => m.ModalTrackPageModule),
  },
  {
    path: 'modal-card-add',
    loadChildren: () => import('./modules/modals/modal-card-add/modal-card-add.module').then( m => m.ModalCardAddPageModule)
  },
  {
    path: 'modal-card-openpay',
    loadChildren: () => import('./modules/modals/modal-card-openpay/modal-card-openpay.module').then( m => m.ModalCardOpenpayPageModule)
  },
  {
    path: 'modal-card-paycode',
    loadChildren: () => import('./modules/modals/modal-card-paycode/modal-card-paycode.module').then( m => m.ModalCardPaycodePageModule)
  },
  {
    path: 'modal-billings',
    loadChildren: () => import('./modules/modals/modal-billings/modal-billings.module').then( m => m.ModalBillingsPageModule)
  },
  {
    path: 'modal-billings-detail',
    loadChildren: () => import('./modules/modals/modal-billings-detail/modal-billings-detail.module').then( m => m.ModalBillingsDetailPageModule)
  },
  {
    path: 'modal-wallet-success',
    loadChildren: () => import('./modules/modals/modal-wallet-success/modal-wallet-success.module').then( m => m.ModalWalletSuccessPageModule)
  },
  {
    path: 'modal-image',
    loadChildren: () => import('./modules/modals/modal-image/modal-image.module').then( m => m.ModalImagePageModule)
  },
  {
    path: 'modal-transaction',
    loadChildren: () => import('./modules/modals/modal-transaction/modal-transaction.module').then( m => m.ModalTransactionPageModule)
  },
  {
    path: 'modal-routes',
    loadChildren: () => import('./modules/modals/modal-routes/modal-routes.module').then( m => m.ModalRoutesPageModule)
  },
  {
    path: 'packages/available',
    canActivate: [GuardService],
    loadChildren: () => import('./modules/packages/available/available.module').then( m => m.AvailablePageModule)
  },
  {
    path: 'packages/add',
    canActivate: [GuardService],
    loadChildren: () => import('./modules/packages/add/add.module').then( m => m.AddPageModule)
  },
  {
    path: 'packages/summary',
    canActivate: [GuardService],
    loadChildren: () => import('./modules/packages/summary/summary.module').then( m => m.SummaryPageModule)
  },
  {
    path: 'packages/bustickets',
    canActivate: [GuardService],
    loadChildren: () => import('./modules/packages/bustickets/bustickets.module').then( m => m.BusticketsPageModule)
  },
  {
    path: 'profile/billing',
    canActivate: [GuardService],
    loadChildren: () => import('./modules/profile/profile-billing/profile-billing.module').then( m => m.ProfileBillingPageModule)
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
